import { useContext, useEffect, useRef } from "react";
import { AccountInfoContext, AccountInfoProvider } from "./AccountInfoContext";
import AccountInfoEmailStep from "./AccountInfoEmailStep";
import AccountInfoOTPStep from "./AccountInfoOTPStep";
import AccountInfoPhoneStep from "./AccountInfoPhoneStep";
import {
  getRemainingExpiration,
  resetExpiration,
} from "../../../utils/getOTPExpirationTime";

/**
 * The main entry into the Account info step of all the booking processes.
 *
 * This step is intended only for users who are trying to book a trip without being logged in.
 * At the end of this step, the user should be registered to go into the payment step.
 *
 * @returns {JSX.Element}
 */

const AccountInfoStepWrapper = () => {
  return (
    <AccountInfoProvider>
      <AccountInfoStep />
    </AccountInfoProvider>
  );
};

const AccountInfoStep = () => {
  const { email, otpDone, setTimer } = useContext(AccountInfoContext);
  const prevEmailRef = useRef(email);
  useEffect(() => {
    if (email && email !== prevEmailRef.current) {
      prevEmailRef.current = email;
      resetExpiration();
      setTimer(getRemainingExpiration());
    }
  }, [email]);
  const inEmailStep = !email;
  if (inEmailStep) {
    return <AccountInfoEmailStep />;
  }
  const inOTPStep = !otpDone;
  if (inOTPStep) {
    return <AccountInfoOTPStep />;
  }
  return <AccountInfoPhoneStep />;
};

export default AccountInfoStepWrapper;
